import { CloseOutlined, GlobalOutlined, LockOutlined, PlusOutlined, SearchOutlined, UserAddOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, DatePicker, Form, Input, InputNumber, Pagination, PaginationProps, Radio, Select, TimePicker, TreeSelect } from 'antd';
import { FormProps } from 'antd/lib';
import { useForm } from 'antd/lib/form/Form';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../Layout';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import './VoucherCreate.scss';
import './VouchersManagement.scss';

import { GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import { useSelector } from 'react-redux';
import { getListFieldsByCustomer, ICustomer } from '../../api/Customer_V2/customerApi_V2';
import { getListALLCustomerIdByGroupAndUser, getListCustomersByGroups, getListCustomersUnmatchedByGroups, IGroupCampaign } from '../../api/campaign/campaignApi';
import { getSLActivityType, getSLCategoryCarByPermission, getSLUnitByPermission, ISelectOption } from '../../api/selectOptions/selectOptionsApi';
import { convertNationwideValueToTree_V2 } from '../../api/unit/unitApi';
import { addCustomersVoucher, addVoucher, addVoucherCodeCustomer } from '../../api/voucher/voucherApi';
import { empty_image_cus } from '../../components/ExportImgFigma';
import { NodataTable } from '../../components/NoDataTable';
import useDebounce from '../../hook/useDebounce';
import useLoading from '../../hook/useLoading';
import useThrottle from '../../hook/useThrottle';
import useToast from '../../hook/useToast';
import { FIELDTYPE, NO_VIEW, VoucherAction } from '../../services/data';
import { formatNumber } from '../../services/mixin';
import { selectorCategoryCarIds } from '../../store/slices/categoryCarSlice';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { dataPagination, fommatSelectOption, fommatSelectOptionTitle, formatPrice } from '../../until';
import { ISelectedCustomer } from '../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { AddType } from '../Customers/CustomerGroup/Component/EditGroup/EditGroup';
import { ColumnKey } from '../Customers/Tabs/CarListCardClone';
import { FlattenedField } from '../CustomersV2/indexV2';
import { dataDefaulFilterList, IDataFilterGroupList } from './AnnouncementCampaign/Create';
import { generateColumnsFromCodesAgGridReactGroup } from './AnnouncementCampaign/Detail/Component/TableLogDetail';
import ModalAddCustomersManually from './VoucherComponents/ModalAddCustomersManually';
import ModalGroupCus from './VoucherComponents/ModalGroupCus';
import { BATCH_SIZE, MAX_DIGITS, } from '../../env';
import { getCLTypeVoucher } from '../../api/selectOption/selectOptionsApi';

const { TextArea } = Input;

export enum VoucherType {
  PUBLIC = 0,
  GROUP = 1,
  PRIVATE = 2,
}


export enum RoleType {
  PRICE = 0,
  PERCENT = 1,
}

export const dataOptionTypeVoucher = [
  { value: 1, label: 'Giảm giá trực tiếp' },
  { value: 2, label: 'Tặng sản phẩm/ dịch vụ' },
  { value: 3, label: 'Mua sản phẩm/ dịch vụ' },
  { value: 4, label: 'Khác' },
]

const VoucherCreate: React.FC = () => {
  useEffect(() => {


    let unmounted = false;
    (async () => {
      const [resCar, resNationwide, resActivityType] = await Promise.all([
        getSLCategoryCarByPermission(permittedCategoryCarIds), getSLUnitByPermission(unitTemp), getSLActivityType()
      ]);
      if (!unmounted && resCar?.status) setSLCategoryCar(fommatSelectOption(resCar.data));
      if (!unmounted && resNationwide?.status) setSLNationwide(convertNationwideValueToTree_V2(resNationwide.data));
      if (!unmounted && resActivityType?.status) setSLActivityType(fommatSelectOption(resActivityType.data));
    })();

  }, []);

  const location = useLocation()

  const cloneData = location?.state?.cloneData || undefined

  const pushToast = useToast();
  const pushLoading = useLoading()
  const navigator = useNavigate()
  const { unitTemp, id } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
  const [form] = useForm();

  const isRestoringSelection = useRef(false);
  const gridApiRef = useRef<GridApi | null>(null);
  const submitAction = useRef<'save' | 'saveAndSend'>('save');
  const prevVoucherType = useRef<string | undefined>(undefined);
  const voucherType = Form.useWatch('voucherType', form)
  const role = Form.useWatch("role", form);
  const quantity = Form.useWatch('quantity', form)
  const typeVoucher = Form.useWatch('typeVoucher', form)

  const [openModalAddGroupCus, setOpenModalAddGroupCus] = useState(false)
  const [openModalAddCustomer, setOpenModalAddCustomer] = useState(false)

  const [sLCategoryCar, setSLCategoryCar] = useState<ISelectOption[]>([]);
  const [sLNationwide, setSLNationwide] = useState<any>()
  const [sLActivityType, setSLActivityType] = useState<ISelectOption[]>([]);

  const [groupCustomerSelected, setGroupCustomerSelected] = useState<IGroupCampaign[]>([])
  // const [groupShow, setGroupShow] = useState<IGroupCampaign[]>([])

  // const [groupCustomerId, setGroupCustomerId] = useState<IGroupCampaign[] | undefined>([])
  const [selectedIds, setSelectedIds] = useState<Set<Number>>(new Set());


  const [selectedIdCustomer, setSelectedIdCustomer] = useState<ISelectedCustomer[]>([]);
  const [selectedIdUnmatchedCustomers, setSelectedIdUnmatchedCustomers] = useState<Set<number>>(new Set());
  const [selectedIdCondUnmatchedCustomersTmp, setSelectedIdUnmatchedCustomersTmp] = useState<Set<number>>(new Set());

  const [listMatchedCustomers, setListMatchedCustomers] = useState<ICustomer[]>([])
  const [listUnmatchedCustomers, setListUnmatchedCustomers] = useState<ICustomer[]>([])

  const [dataFilterMatchedCustomers, setDataFilterMatchedCustomers] = useState<IDataFilterGroupList>(dataDefaulFilterList)
  const [dataFilterUnmatchedCustomers, setDataFilterUnmatchedCustomers] = useState<IDataFilterGroupList>(dataDefaulFilterList)
  const [sLTypeVoucher, setSLTypeVoucher] = useState<any[]>([])

  const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])
  const [dataFieldsActive, setDataFieldsActive] = useState<FlattenedField[]>([])


  const [paginationMatchedCustomers, setPaginationMatchedCustomers] = useState({ current: 1, pageSize: 30, total: 0 });
  const [paginationUnmatchedCustomers, setPaginationUnmatchedCustomers] = useState({ current: 1, pageSize: 30, total: 0 });

  //#region Validate input số chỉ cho nhập số, không cho nhập âm, tối đa 12 chữ số

  const hasNegativeSign = (value: string) => {
    return value.includes('-');
  };

  const hasInvalidCharacter = (value: string) => {
    // Cho phép số, dấu chấm, dấu trừ để validator tự báo lỗi âm
    return /[^\d.-]/.test(value);
  };

  const getRawNumberString = (value: unknown) => {
    return String(value || '').replace(/\./g, '');
  };

  const getDigitsOnly = (value: string) => {
    return value.replace(/\D/g, '');
  };

  const formatNumberWithDot = (value: string) => {
    const rawValue = getDigitsOnly(value);

    return rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const normalizeNumberInput = (value: string) => {
    const digitsOnly = getDigitsOnly(value);

    // Nếu nhập ký tự lạ thì giữ nguyên để validator báo lỗi
    if (hasInvalidCharacter(value)) {
      return value;
    }

    // Nếu nhập dấu âm thì giữ nguyên để validator báo lỗi "Không được nhập số âm"
    if (hasNegativeSign(value)) {
      return value;
    }

    // Nếu nhập quá 12 chữ số thì giữ nguyên để validator báo lỗi
    if (digitsOnly.length > MAX_DIGITS) {
      return value;
    }

    // Hợp lệ thì format
    return formatNumberWithDot(value);
  };


  const validatePositiveNumberMax12 = (_: unknown, value: unknown) => {
    const text = String(value || '');

    if (!text) {
      return Promise.resolve();
    }

    if (hasInvalidCharacter(text)) {
      return Promise.reject(new Error('Chỉ được nhập số'));
    }

    if (hasNegativeSign(text)) {
      return Promise.reject(new Error('Không được nhập số âm'));
    }

    const rawValue = getRawNumberString(text);

    if (!/^\d+$/.test(rawValue)) {
      return Promise.reject(new Error('Chỉ được nhập số'));
    }

    if (rawValue.length > MAX_DIGITS) {
      return Promise.reject(new Error('Tối đa 12 chữ số'));
    }

    if (Number(rawValue) <= 0) {
      return Promise.reject(new Error('Giá trị phải lớn hơn 0'));
    }

    return Promise.resolve();
  };
  //#endregion


  //#region column




  const gListFieldsActive = async () => {
    const result = await getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 1)
    if (result?.status) {
      const flattenedFields = result.data.flatMap(choice =>
        choice.fields.map(field => ({
          ...field,
          parentId: choice.id,
        }))
      );
      setDataFieldsActive(flattenedFields)
      // gListFieldsNotActive()
    }
  }

  //#endregion

  // kh k co dk

  // Key theo id nhóm — chỉ refetch khi thay đổi nhóm, không refetch khi total cập nhật
  const groupSelectedIdsKey = useMemo(
    () => groupCustomerSelected.map(i => Number(i.id)).sort().join(','),
    [groupCustomerSelected]
  )

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReactGroup(
      ColumnsMapShow, dataFieldsActive, undefined
    );
  }, [ColumnsMapShow]);


  //dk all
  const tableDataMatchedCustomers: any[] = useMemo(() => {
    return listMatchedCustomers.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listMatchedCustomers])

  const tableDataUnmatchedCustomers: any[] = useMemo(() => {
    return listUnmatchedCustomers.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listUnmatchedCustomers])
  //------------------------------------


  //#region cấu hình chọn bảng
  // Định danh duy nhất cho mỗi row
  const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

  // --- Grid ready ---
  // const onGridReady = useCallback((params: { api: GridApi }) => {
  //   gridApiRef.current = params.api;
  // }, []);

  const restoreGridSelection = useCallback(() => {
    if (!gridApiRef.current) return;

    const hasGroup =
      groupCustomerSelected.length > 0;

    const idsToSelect = hasGroup
      ? selectedIds
      : selectedIdCondUnmatchedCustomersTmp;

    isRestoringSelection.current = true;

    gridApiRef.current.forEachNode(node => {
      if (!node.data) return;

      node.setSelected(
        idsToSelect.has(Number(node.data.id)),
        false
      );
    });

    setTimeout(() => {
      isRestoringSelection.current = false;
    }, 0);

  }, [
    groupCustomerSelected.length,
    selectedIds,
    selectedIdCondUnmatchedCustomersTmp,
  ]);

  const onGridReady = useCallback(
    (params: { api: GridApi }) => {
      gridApiRef.current = params.api;

      setTimeout(() => {
        restoreGridSelection();
      }, 0);
    },
    [restoreGridSelection]
  );

  useEffect(() => {
    restoreGridSelection();
  }, [
    tableDataMatchedCustomers,
    tableDataUnmatchedCustomers,
    restoreGridSelection,
  ]);


  // --- Selection change ---
  const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {
    if (isRestoringSelection.current) return;

    const api = event.api;
    const selectedNodes = api.getSelectedNodes().filter(n => n.data);
    const selectedIdsOnPage = selectedNodes.map(n => Number(n.data.id));

    const currentPageIds = (tableDataMatchedCustomers ?? []).map((row: any) => Number(row.id));

    // --- Tạo bản sao của selectedIds hiện tại ---
    const nextSet = new Set(selectedIds);

    // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
    const added: number[] = [];
    const removed: number[] = [];

    // Kiểm tra từng ID trên trang hiện tại
    for (const id of currentPageIds) {
      const isCurrentlySelected = selectedIdsOnPage.includes(id);
      const wasPreviouslySelected = selectedIds.has(id);

      if (isCurrentlySelected && !wasPreviouslySelected) {
        // ID mới được chọn
        added.push(id);
        nextSet.add(id);
      } else if (!isCurrentlySelected && wasPreviouslySelected) {
        // ID bị bỏ chọn
        removed.push(id);
        nextSet.delete(id);
      }
    }

    setSelectedIds(nextSet);
    // 👉 Cập nhật danh sách selected account
    handleChangeSelectedCustomer(added, removed);

  }, [selectedIds, tableDataMatchedCustomers,]);

  const onSelectionChangedUnMatch = useCallback((event: SelectionChangedEvent) => {
    if (isRestoringSelection.current) return;
    const api = event.api;
    const selectedNodes = api.getSelectedNodes().filter(n => n.data);
    const selectedIdsOnPage = selectedNodes.map(n => Number(n.data.id));

    const currentPageIds = (tableDataUnmatchedCustomers ?? []).map((row: any) => Number(row.id));

    // --- Tạo bản sao của selectedIds hiện tại ---
    const nextSet = new Set(selectedIdCondUnmatchedCustomersTmp);

    // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
    const added: Number[] = [];
    const removed: Number[] = [];

    // Kiểm tra từng ID trên trang hiện tại
    for (const id of currentPageIds) {
      const isCurrentlySelected = selectedIdsOnPage.includes(id);
      const wasPreviouslySelected = selectedIdCondUnmatchedCustomersTmp.has(id);

      if (isCurrentlySelected && !wasPreviouslySelected) {
        // ID mới được chọn
        added.push(id);
        nextSet.add(id);
      } else if (!isCurrentlySelected && wasPreviouslySelected) {
        // ID bị bỏ chọn
        removed.push(id);
        nextSet.delete(id);
      }
    }
    setSelectedIdUnmatchedCustomersTmp(nextSet);
  }, [
    listUnmatchedCustomers, selectedIdCondUnmatchedCustomersTmp

  ]);

  useEffect(() => {
    const Ids = new Set(
      selectedIdCustomer.map(item => item.customerId)
    );
    setSelectedIds(Ids);
  }, [selectedIdCustomer])
  //------------------------------------
  //#endregion

  //Kh có dk ds xem trước
  const handleChangeCondSelectIdCustomerView: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>> = (value) => {
    // Chuẩn hoá về mảng ISelectedCustomer[]
    const nextArray =
      typeof value === 'function'
        ? value(selectedIdCustomer) // selectedIdCustomerV9: state hiện tại
        : value;

    // Lấy danh sách customerId từ mảng value
    const valueIds = new Set(nextArray.map(v => v.customerId));

    // Giả sử selectedIdNoCondCustomerManual vẫn là Set<number>
    const nextB = new Set(
      [...selectedIdUnmatchedCustomers].filter(x => valueIds.has(x))
    );

    // Cập nhật state chính
    setSelectedIdCustomer(value);
    // Kiểm tra hai Set có giống nhau không
    const areSetsEqual =
      selectedIdUnmatchedCustomers.size === nextB.size &&
      [...selectedIdUnmatchedCustomers].every(v => nextB.has(v));

    if (!areSetsEqual) {
      setSelectedIdUnmatchedCustomers(nextB);
    }
  }


  // --- Cập nhật danh sách account được chọn ---
  // const handleChangeSelectedCustomer = (itemsAdd: number[] = [], itemsRemove: number[] = []) => {
  //   handleChangeCondSelectIdCustomerView((prev) =>
  //     itemsAdd.length ?
  //       [
  //         ...prev,
  //         ...itemsAdd
  //           .filter((id) => !prev.some((u) => u.customerId === id))
  //           .map((id) => ({ customerId: id, addType: AddType.Auto })),
  //       ] :
  //       itemsRemove.length ?
  //         prev.filter((u) => !itemsRemove.includes(u.customerId)) :
  //         prev
  //   );

  //   setSelectedIdCustomer((prev) =>
  //     itemsAdd.length ?
  //       [
  //         ...prev,
  //         ...itemsAdd
  //           .filter((id) => !prev.some((u) => u.customerId === id))
  //           .map((id) => ({ customerId: id, addType: AddType.Auto })),
  //       ] :
  //       itemsRemove.length ?
  //         prev.filter((u) => !itemsRemove.includes(u.customerId)) :
  //         prev
  //   );
  // };
  const handleChangeSelectedCustomer = (
    itemsAdd: number[] = [],
    itemsRemove: number[] = []
  ) => {
    handleChangeCondSelectIdCustomerView((prev) =>
      itemsAdd.length
        ? [
          ...prev,
          ...itemsAdd
            .filter(id => !prev.some(x => x.customerId === id))
            .map(id => ({
              customerId: id,
              addType: AddType.Auto,
            })),
        ]
        : itemsRemove.length
          ? prev.filter(x => !itemsRemove.includes(x.customerId))
          : prev
    );
  };

  // --- Khôi phục selection khi data mới load ---
  // useEffect(() => {
  //   if (gridApiRef.current && tableDataMatchedCustomers && tableDataMatchedCustomers.length > 0) {
  //     isRestoringSelection.current = true;

  //     gridApiRef.current.forEachNode((node: any) => {
  //       if (node.data && selectedIds.has(Number(node.data.id))) {
  //         node.setSelected(true, false, true);
  //       } else {
  //         node.setSelected(false, false, true);
  //       }
  //     });

  //     setTimeout(() => {
  //       isRestoringSelection.current = false;
  //     }, 0);
  //   }
  // }, [tableDataMatchedCustomers, selectedIds]);
  useEffect(() => {
    if (!gridApiRef.current) return;

    const hasGroup = groupCustomerSelected.length > 0;

    const currentData = hasGroup
      ? tableDataMatchedCustomers
      : tableDataUnmatchedCustomers;

    if (!currentData?.length) return;

    const idsToSelect = hasGroup
      ? selectedIds
      : selectedIdCondUnmatchedCustomersTmp;

    // console.log(
    //   "Restore checkbox:",
    //   Array.from(idsToSelect)
    // );

    isRestoringSelection.current = true;

    gridApiRef.current.forEachNode((node: any) => {
      if (!node.data) return;

      const id = Number(node.data.id);

      node.setSelected(
        idsToSelect.has(id),
        false
      );
    });

    setTimeout(() => {
      isRestoringSelection.current = false;
    }, 0);

  }, [
    tableDataMatchedCustomers,
    tableDataUnmatchedCustomers,
    selectedIds,
    selectedIdCondUnmatchedCustomersTmp,
    groupCustomerSelected.length,
  ]);

  //------------------------------------ End SELECT

  const gSLTypeVoucher = async () => {
    pushLoading(true)
    const result = await getCLTypeVoucher()
    if (result?.status) {
      setSLTypeVoucher(fommatSelectOptionTitle(result.data))
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }


  //#region  Chọn nhóm kh api
  const gListCustomersByGroups = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

    const { listCategoryCar, listUnit, search } = dataFilterMatchedCustomers
    const groupCustomerSelectedTmp = groupCustomerSelected?.map(i => i.id) || []
    const selectedIdUnmatchedCustomersTmp = Array.from(selectedIdUnmatchedCustomers)
    pushLoading(true)

    const result = await getListCustomersByGroups(
      groupCustomerSelectedTmp,
      pageSize, pageCurent, unitTemp, listUnit,
      listCategoryCar, search, selectedIdUnmatchedCustomersTmp
    )
    if (result?.status) {
      setListMatchedCustomers(result.data.customersFinal)
      // Chỉ set khi group thay đổi thật sự (id + total), tránh loop useEffect (reference mới mỗi response)
      setGroupCustomerSelected((prev) => {
        const toKey = (list: IGroupCampaign[]) =>
          list.map(i => `${Number(i.id)}:${i.total}`).sort().join(',')
        return toKey(prev) === toKey(result.data.groups || []) ? prev : result.data.groups
      })

      setPaginationMatchedCustomers({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const gListCustomersUnmatchedByGroups = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    const selectId = groupCustomerSelected?.map(i => i.id) || []
    const { listCategoryCar, listUnit, search } = groupCustomerSelected?.length ? dataFilterUnmatchedCustomers : dataFilterMatchedCustomers

    pushLoading(true)

    const result = await getListCustomersUnmatchedByGroups(
      selectId,
      pageSize, pageCurent, unitTemp, listUnit,
      listCategoryCar, search
    )
    if (result?.status) {
      setListUnmatchedCustomers(result.data)
      setPaginationUnmatchedCustomers({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const gListALLCustomerIdByGroupAndUser = useDebounce(async () => {
    const selectId = groupCustomerSelected?.map(i => i.id) || []
    pushLoading(true)

    const result = await getListALLCustomerIdByGroupAndUser(
      selectId
    )
    if (result?.status) {
      setSelectedIdCustomer(result.data)
      // setSelectedIdUnmatchedCustomers(new Set())
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)
  //#endregion


  //#region  Func Nhóm

  const removeGroupCustomerSelected = (id: number) => {
    setGroupCustomerSelected((prev) =>
      prev.filter((item: IGroupCampaign) => Number(item.id) !== Number(id))
    );
  };


  //#endregion



  // FORM SUBMIT

  const formatDate = (date: any) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0") // Tháng bắt đầu từ 0 nên cần cộng thêm 1
    const day = (date.getDate()).toString().padStart(2, "0")
    const hours = (date.getHours()).toString().padStart(2, "0")
    const minutes = (date.getMinutes()).toString().padStart(2, "0")

    return {
      date: `${year}-${month}-${day}`,
      time: `${hours}:${minutes}`
    }
  };

  const checkDate = (startDate?: string, startTime?: string, endDate?: string, endTime?: string) => {

    const dateStart1 = new Date(startDate?.toString() || "");
    const dateStart2 = new Date(startTime?.toString() || "");

    const mergedDateStart = new Date(
      dateStart1.getFullYear(), // Lấy năm từ chuỗi thứ hai
      dateStart1.getMonth(),    // Lấy tháng từ chuỗi thứ hai
      dateStart1.getDate(),     // Lấy ngày từ chuỗi thứ hai
      dateStart2.getHours(),    // Lấy giờ từ chuỗi đầu tiên
      dateStart2.getMinutes(),  // Lấy phút từ chuỗi đầu tiên
    );

    const dateEnd1 = new Date(endDate?.toString() || "");
    const dateEnd2 = new Date(endTime?.toString() || "");

    const mergedDateEnd = new Date(
      dateEnd1.getFullYear(), // Lấy năm từ chuỗi thứ hai
      dateEnd1.getMonth(),    // Lấy tháng từ chuỗi thứ hai
      dateEnd1.getDate(),     // Lấy ngày từ chuỗi thứ hai
      dateEnd2.getHours(),    // Lấy giờ từ chuỗi đầu tiên
      dateEnd2.getMinutes(),  // Lấy phút từ chuỗi đầu tiên
    );

    const startDateTMP = formatDate(mergedDateStart)
    const endDateTMP = formatDate(mergedDateEnd)
    if (mergedDateEnd > mergedDateStart) {

      return (
        {
          isSS: true,
          startDate: startDateTMP.date,
          startTime: startDateTMP.time,
          endDate: endDateTMP.date,
          endTime: endDateTMP.time
        }
      )
    } else {
      return (
        {
          isSS: false,
          startDate: startDateTMP.date,
          startTime: startDateTMP.time,
          endDate: endDateTMP.date,
          endTime: endDateTMP.time
        }
      )
    }

  }

  const handleChangeCondSelectIdCustomerManual = (value: Set<number>) => {
    // 1) Cập nhật danh sách selectedIdCustomerV9 (thêm + xóa theo diff)
    setSelectedIdCustomer(prevList => {
      // Tìm các id bị bỏ chọn (có trong selectedIdUnmatchedCustomers nhưng không còn trong value)
      const removedIds = new Set<number>();
      selectedIdUnmatchedCustomers.forEach(id => {
        if (!value.has(id)) removedIds.add(id);
      });

      // a) XÓA: loại bỏ các item Manual có customerId thuộc removedIds
      const kept = prevList.filter(item => {
        // nếu bị bỏ chọn -> loại
        if (removedIds.has(item.customerId)) return false;
        return true; // còn lại giữ
      });

      // b) THÊM: thêm các id mới từ value nếu chưa có trong kept
      const byId = new Map<number, ISelectedCustomer>(kept.map(c => [c.customerId, c]));
      value.forEach(id => {
        if (!byId.has(id)) {
          byId.set(id, { customerId: id, addType: AddType.Manual });
        }
      });

      return Array.from(byId.values());
    });
    // 2) Đồng bộ lại "bộ chọn" unmatched hiện tại
    setSelectedIdUnmatchedCustomers(value);
  };

  //Kh có dk


  // phần ni pagination cho modal thêm khách hàngngf
  const onPaginationUnmatchedCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListCustomersUnmatchedByGroups(pageNumber, pageSize)
  }

  const onPagination: PaginationProps['onChange'] = (pageNumber, pageSize) => {

    if (groupCustomerSelected?.length) {
      gListCustomersByGroups(pageNumber, pageSize)
    } else {
      gListCustomersUnmatchedByGroups(pageNumber, pageSize)
    }
  }




  const addCustomersInChunks = async (voucherId: number, customerId: ISelectedCustomer[]) => {
    for (let i = 0; i < customerId.length; i += BATCH_SIZE) {
      const chunk = customerId.slice(i, i + BATCH_SIZE);

      let success = false;
      let retryCount = 0;

      while (!success) {
        try {
          await addCustomersVoucher(voucherId, chunk);
          success = true;

        } catch (error) {
          retryCount++;

          // delay trước khi retry
          await new Promise(r => setTimeout(r, 1000));
        }
      }

      // delay giữa các batch
      await new Promise(r => setTimeout(r, 50));
    }
    navigator('/marketing/vouchers-management')

  };

  const addVouchersCustomerInChunks = async (voucherId: number, customerId: ISelectedCustomer[]) => {

    // ✅ Lấy số lượng nhỏ hơn giữa quantity và số lượng customerId thực tế
    const actualQuantity = Math.min(quantity, customerId.length);
    const customers = customerId.slice(0, actualQuantity);


    // for (let i = 0; i < customers.length; i += BATCH_SIZE) {
    //   const chunk = customers.slice(i, i + BATCH_SIZE); // ✅ Dùng customers

    //   let success = false;
    //   let retryCount = 0;
    //   const MAX_RETRIES = 3;

    //   while (!success && retryCount < MAX_RETRIES) {
    //     try {
    //       await addVoucherCodeCustomer(voucherId, chunk);
    //       success = true;
    //     } catch (error) {
    //       retryCount++;
    //       console.error(`Chunk ${i / BATCH_SIZE + 1} failed (retry ${retryCount})`, error);

    //       if (retryCount < MAX_RETRIES) {
    //         await new Promise(r => setTimeout(r, 1000 * Math.pow(2, retryCount - 1)));
    //       } else {
    //         throw error;
    //       }
    //     }
    //   }

    //   await new Promise(r => setTimeout(r, 50));
    // }

    navigator(-1);
  };

  const onFinish: FormProps["onFinish"] = useThrottle(async (values: any) => {

    const data = checkDate(values?.startDate, values.startTime, values.endDate, values.endTime)
    if (!data.isSS) {
      pushToast("Ngày bắt đầu phải nhỏ hơn ngày kết thúc", "warning")
      return
    }

    const {
      title, description, issuedUnitId, appliedUnitIds, appliedBrandIds,
      appliedActivityTypeIds, approvedUnitId, voucherType, quantity,
      role, reducedAmount, orderValueMin, reducedAmountMaximum, percentDecrease,
      startDate, startTime, endDate, endTime, termsOfUse, typeVoucher
    } = values
    pushLoading(true)
    const type = values.voucherType === "public" ? 0 : values.voucherType === "group" ? 1 : 2
    const startDateTmp = startDate ? startDate?.format("YYYY/MM/DD") : undefined;
    const endDateTmp = endDate ? endDate?.format("YYYY/MM/DD") : undefined;
    const startTimeTmp = startTime.format('HH:mm');
    const endTimeTmp = endTime.format('HH:mm');
    const status = submitAction.current === 'save' ? VoucherAction.SAVE : VoucherAction.SAVEANDSEND


    const idGroup = type === VoucherType.GROUP ? groupCustomerSelected?.map(i => Number(i.id)) || [] : undefined
    const idCustomer = type === VoucherType.PRIVATE ? selectedIdCustomer?.map(i => Number(i.customerId)) || [] : undefined
    const idCustomerNoGroup = type === VoucherType.PRIVATE ?
      selectedIdCondUnmatchedCustomersTmp.size > 0 ?
        Array.from(selectedIdCondUnmatchedCustomersTmp) :
        [] :
      undefined

    const idCustomerNoGroupFinal = idCustomerNoGroup && idCustomerNoGroup.map((item) => ({
      customerId: item,
      addType: 0,
    }));


    const idCustomerFinal = selectedIdCustomer && selectedIdCustomer.length > 0
      ? selectedIdCustomer
      : idCustomerNoGroupFinal

    // const usageCountTmp = Number(String(usageCount ?? '').replace(/\./g, ''))
    const orderValueMinTmp = Number(String(orderValueMin ?? '').replace(/\./g, ''))
    const reducedAmountMaximumTmp = Number(String(reducedAmountMaximum ?? '').replace(/\./g, ''))
    const quantityTmp = Number(String(quantity ?? '').replace(/\./g, ''))
    const reducedAmountTmp = role === RoleType.PRICE ? Number(String(reducedAmount ?? '').replace(/\./g, '')) : undefined
    // const reducedAmountMaximumTmp = role === RoleType.PRICE ? Number(String(reducedAmountMaximum ?? '').replace(/\./g, '')) : undefined

    const result = await addVoucher(
      title, description, type, orderValueMinTmp,
      startDateTmp, startTimeTmp, endDateTmp, endTimeTmp, typeVoucher, quantityTmp, issuedUnitId,
      appliedUnitIds, appliedBrandIds, appliedActivityTypeIds,
      approvedUnitId, idGroup,
      reducedAmountTmp, percentDecrease, reducedAmountMaximumTmp, status, termsOfUse
    )
    if (result?.status) {
      if (idCustomerFinal) {
        await addCustomersInChunks(result.data.voucherId, idCustomerFinal)
        // await addVouchersCustomerInChunks(result.data.voucherId, idCustomerFinal)
      } else {
        navigator('/marketing/vouchers-management')
      }
      pushToast(result.message, "success")
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)

  }, 1000)

  useEffect(() => {
    const codes = dataFieldsActive.map(f => f.fieldCode)
    setColumnsMapShow(codes)
  }, [dataFieldsActive])

  //#region  Chọn nhóm kh useEffect thay đổi nhóm
  useEffect(() => {
    if (prevVoucherType.current !== 'private' && voucherType !== 'group') {
      setDataFilterMatchedCustomers(dataDefaulFilterList)
      setDataFilterUnmatchedCustomers(dataDefaulFilterList)

      setPaginationMatchedCustomers({ current: 1, pageSize: 30, total: 0 })
      setPaginationUnmatchedCustomers({ current: 1, pageSize: 30, total: 0 })

      setSelectedIdCustomer([])
      setSelectedIdUnmatchedCustomers(new Set())

      if (voucherType === 'private')
        gListCustomersUnmatchedByGroups()

      if (groupCustomerSelected.length) {
        gListALLCustomerIdByGroupAndUser()
      } else {
        setListMatchedCustomers([])
      }
    }

  }, [voucherType])

  useEffect(() => {


    if (voucherType === 'public') return
    if (groupCustomerSelected.length) {
      gListCustomersByGroups()
    }
    else {
      gListCustomersUnmatchedByGroups()
    }

  }, [dataFilterMatchedCustomers, groupSelectedIdsKey, selectedIdUnmatchedCustomers])


  useEffect(() => {
    if (voucherType === 'private')
      gListCustomersUnmatchedByGroups()
  }, [dataFilterUnmatchedCustomers])


  useEffect(() => {
    const prev = prevVoucherType.current;

    if (prev === "private" && voucherType === "group") {
      setGroupCustomerSelected([]);
      setSelectedIdCustomer([]);
      setSelectedIds(new Set());
      setSelectedIdUnmatchedCustomers(new Set());
      setSelectedIdUnmatchedCustomersTmp(new Set());
      setListMatchedCustomers([]);
      setListUnmatchedCustomers([]);
      setDataFilterMatchedCustomers(dataDefaulFilterList);
      setDataFilterUnmatchedCustomers(dataDefaulFilterList);
    }

    if (voucherType === "private") {
      gListFieldsActive();
    }

    prevVoucherType.current = voucherType;
  }, [voucherType]);

  // đổi đv phạm vị => clear
  useEffect(() => {
    setGroupCustomerSelected([]);
    setSelectedIdCustomer([]);
    setSelectedIds(new Set());
    setSelectedIdUnmatchedCustomers(new Set());
    setSelectedIdUnmatchedCustomersTmp(new Set());
    setListMatchedCustomers([]);
    setListUnmatchedCustomers([]);
    setDataFilterMatchedCustomers(dataDefaulFilterList);
    setDataFilterUnmatchedCustomers(dataDefaulFilterList);
    if (voucherType === 'group') {
      gListCustomersByGroups()
    }
    if (voucherType === 'private') {
      gListCustomersUnmatchedByGroups()
    }
  }, [unitTemp])

  useEffect(() => {
    gSLTypeVoucher()
  }, [])



  // set thong tin cho form nếu nhân bản

  useEffect(() => {
    if (
      // infoCampaign?.channelList?.some(c => (c.templates?.length ?? 0) > 1) &&
      // infoCampaign && isFirstLoadApi.current
      location && cloneData
    ) {
      const { title, description, type, issuedUnitId, appliedUnitIds, appliedBrandIds, appliedActivityTypeIds, approvedUnitId, quantity, percentDecrease, reducedAmount, orderValueMin, reducedAmountMaximum, termsOfUse, typeVoucher, voucherType, role, voucherGroupCustomers } = cloneData

      const parseDate = (val?: string) => {
        if (!val) return undefined;
        const d = dayjs(val, "DD/MM/YYYY", true);
        return d.isValid() ? d : dayjs(val);
      };
      const dateStartTmp = parseDate(cloneData?.dateStart);
      const timeStartTmp = cloneData?.timeStart ? dayjs(cloneData.timeStart, "HH:mm") : undefined;
      const dateEndTmp = parseDate(cloneData?.dateEnd);
      const timeEndTmp = cloneData?.timeEnd ? dayjs(cloneData.timeEnd, "HH:mm") : undefined;
      // const role = percentDecrease ? RoleType.PERCENT : RoleType.PRICE

      const clonedCustomers: ISelectedCustomer[] =
        cloneData.voucherCustomers?.map(
          (item: { id: number | string; addType: number }) => ({
            customerId: Number(item.id),
            addType: item.addType,
          })
        ) ?? [];

      setSelectedIdCustomer(clonedCustomers);

      // Set ID để AG Grid restore checkbox
      const clonedIds = new Set<number>(
        clonedCustomers.map(item => item.customerId)
      );

      setSelectedIds(clonedIds);

      // Nếu voucher private không có group
      // thì table đang dùng selectedIdCondUnmatchedCustomersTmp
      setSelectedIdUnmatchedCustomersTmp(clonedIds);

      // Set group customers for private vouchers
      if (voucherType === 1 && voucherGroupCustomers) {
        setGroupCustomerSelected(voucherGroupCustomers);
      }

      form.setFieldsValue({
        title,
        description,
        issuedUnitId: issuedUnitId,
        appliedUnitIds,
        appliedBrandIds,
        appliedActivityTypeIds,
        approvedUnitId: approvedUnitId,
        voucherType: voucherType === 0 ? "public" : voucherType === 1 ? "group" : "private",
        quantity,
        role,
        percentDecrease,
        reducedAmount,
        typeVoucher: typeVoucher,
        orderValueMin,
        reducedAmountMaximum,
        startDate: dateStartTmp,
        startTime: timeStartTmp,
        endDate: dateEndTmp,
        endTime: timeEndTmp,
        termsOfUse,

      })
    }

  }, [location])

  return (
    <Layout contentClassName="voucher-management-content">

      <ModalGroupCus
        open={openModalAddGroupCus}
        groupCustomerSelected={groupCustomerSelected}

        setGroupCustomerSelected={setGroupCustomerSelected}

        onClose={() => setOpenModalAddGroupCus(false)}
      />

      <ModalAddCustomersManually
        isOpen={openModalAddCustomer}
        sLCategoryCar={sLCategoryCar}
        sLNationwide={sLNationwide}
        memoizedColumnDefs={memoizedColumnDefs}

        dataFilterUnmatchedCustomers={dataFilterUnmatchedCustomers}
        paginationUnmatchedCustomers={paginationUnmatchedCustomers}

        selectedIdUnmatchedCustomers={selectedIdUnmatchedCustomers}

        listUnmatchedCustomers={tableDataUnmatchedCustomers}
        onPaginationUnmatchedCustomers={onPaginationUnmatchedCustomers}

        setSelectedIdUnmatchedCustomers={handleChangeCondSelectIdCustomerManual}

        setDataFilterUnmatchedCustomers={setDataFilterUnmatchedCustomers}


        closeModal={() => setOpenModalAddCustomer(false)}
      />

      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: 'Marketing', },
          { title: <Link to="/marketing/vouchers-management">Quản lý Voucher</Link>, },
          { title: 'Tạo mới', },
        ]}
        title='Tạo mới voucher'
        backLink='/marketing/vouchers-management'
      />
      <div
        style={{ flexGrow: 1 }}
      >
        <Form
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          initialValues={{
            voucherType: 'public',
            applyConditions: [{}],
            useConditions: [{}],
          }}
          className="custom-page-css w-full flex flex-col gap-1"
        >
          <div className="custom-page-css w-full flex flex-col gap-3">
            <div className="custom-page-css w-full flex items-center justify-between">
              <span className="font-regular lh-24 fsz-14">Thông tin chương trình</span>
              <div className="custom-page-css flex items-center gap-2">
                <Button
                  type='link'
                  className='custom-page-css border-096DD9'
                  onClick={() => {
                    submitAction.current = 'save';
                    form.submit()
                  }}
                >
                  Lưu
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    submitAction.current = 'saveAndSend';
                    form.submit()
                  }}
                >Lưu và gửi duyệt</Button>
              </div>
            </div>
            <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Tên chương trình Voucher <span className='text-danger'>*</span> </span>

            <Form.Item
              name="title"
              rules={[{ required: true, message: 'Vui lòng nhập tên chương trình!' }]}
            >
              <Input
                placeholder="Tên chương trình Voucher"
                className="custom-input-css custom-page-css border"
              />
            </Form.Item>
          </div>
          <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Mô tả</span>
          <Form.Item
            name="description"
          >
            <TextArea
              placeholder="Nội dung mô tả về chương trình Voucher"
              className="custom-input-css custom-page-css border"
            />
          </Form.Item>

          <div className="custom-page-css w-full grid grid-cols-2 gap-2">
            <div className="custom-page-css flex flex-col gap-2">
              <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Đơn vị phát hành <span className='text-danger'>*</span></span>
              <Form.Item
                name="issuedUnitId"
                rules={[{ required: true, message: 'Vui lòng chọn đơn vị phát hành!' }]}
              >
                <TreeSelect
                  className={'custom-page-css border rounded overflow-hidden'}
                  showSearch
                  placeholder="Đơn vị phát hành"
                  allowClear
                  treeDefaultExpandAll={false}
                  treeData={sLNationwide}
                  filterTreeNode={(input: string, option: any) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                />
              </Form.Item>
            </div>
            <div className="custom-page-css flex flex-col gap-2">
              <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Đơn vị áp dụng <span className='text-danger'>*</span></span>
              <Form.Item
                name="appliedUnitIds"
                rules={[{ required: true, message: 'Vui lòng chọn đơn vị áp dụng!' }]}
              >
                <TreeSelect
                  className={'custom-page-css border rounded overflow-hidden'}
                  showSearch
                  multiple
                  placeholder="Đơn vị áp dụng"
                  allowClear
                  treeDefaultExpandAll={false}
                  treeData={sLNationwide}
                  filterTreeNode={(input: string, option: any) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                />
              </Form.Item>
            </div>
            <div className="custom-page-css flex flex-col gap-2">
              <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Thương hiệu áp dụng <span className='text-danger'>*</span></span>
              <Form.Item
                name="appliedBrandIds"
                rules={[{ required: true, message: 'Vui lòng chọn thương hiệu áp dụng!' }]}
              >
                <Select
                  className='custom-page-css border rounded overflow-hidden'
                  placeholder='Thương hiệu áp dụng'
                  allowClear
                  mode="multiple"
                  options={sLCategoryCar}
                />
              </Form.Item>
            </div>
            <div className="custom-page-css flex flex-col gap-2">
              <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Hoạt động áp dụng <span className='text-danger'>*</span></span>
              <Form.Item
                name="appliedActivityTypeIds"
                rules={[{ required: true, message: 'Vui lòng chọn hoạt động áp dụng!' }]}

              >
                <Select
                  className='custom-page-css border rounded overflow-hidden'
                  placeholder='Hoạt động áp dụng'
                  allowClear
                  mode="multiple"
                  options={sLActivityType}
                />
              </Form.Item>
            </div>
            <div className="custom-page-css flex flex-col gap-2">
              <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Đơn vị duyệt chương trình voucher <span className='text-danger'>*</span></span>
              <Form.Item
                name="approvedUnitId"
                rules={[{ required: true, message: 'Vui lòng chọn duyệt chương trình voucher' }]}
              >
                <TreeSelect
                  className={'custom-page-css border rounded overflow-hidden'}
                  showSearch
                  placeholder="Đơn vị duyệt chương trình voucher"
                  allowClear
                  treeDefaultExpandAll={false}
                  treeData={sLNationwide}
                  filterTreeNode={(input: string, option: any) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                />
              </Form.Item>
            </div>
            <div className="custom-page-css flex flex-col gap-2">
              <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Loại voucher <span className='text-danger'>*</span></span>
              <Form.Item
                name="typeVoucher"
                rules={[{ required: true, message: 'Vui lòng chọn loại voucher!' }]}

              >
                <Select
                  className='custom-page-css border rounded overflow-hidden'
                  placeholder='Chọn loại voucher'
                  allowClear
                  options={sLTypeVoucher}
                />
              </Form.Item>
            </div>
          </div>
          <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Thông tin voucher</span>
          <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Loại hình</span>
          <Form.Item
            name="voucherType"
            rules={[{ required: true, message: 'Vui lòng chọn loại voucher!' }]}
          >
            <Radio.Group
              className="rs-radio-group rs-radio-group--button voucher-type-group custom-page-css grid grid-cols-3 gap-3"
            >
              <Radio.Button
                value="public"
                className={`${voucherType === 'public' ? 'bg-active-voucher-card' : ''}  rs-radio rs-radio--button `}
              >
                <GlobalOutlined />
                <div className="custom-page-css flex flex-col gap-1">
                  <div className="lh-24 font-regular fsz-14  text-344054">Voucher công khai</div>
                  <div className="lh-24 fsz-13  text-344054 break-word"
                  >Là loại Voucher bất kỳ khách hàng nào có mã đều dùng được.</div>
                </div>
              </Radio.Button>
              <Radio.Button
                value="group"
                className={`${voucherType === 'group' ? 'bg-active-voucher-card' : ''}  rs-radio rs-radio--button `}
              >
                <LockOutlined />
                <div className="custom-page-css flex flex-col gap-1">
                  <div className="lh-24 font-regular fsz-14  text-344054">Voucher cho nhóm</div>
                  <div className="lh-24 fsz-13  text-344054 break-word">Là loại Voucher chỉ dành cho một tập khách hàng được chọn.</div>
                </div>
              </Radio.Button>
              <Radio.Button
                value="private"
                className={`${voucherType === 'private' ? 'bg-active-voucher-card' : ''}  rs-radio rs-radio--button `}
              >
                <UserAddOutlined />
                <div className="custom-page-css flex flex-col gap-1">
                  <div className="lh-24 font-regular fsz-14  text-344054">Voucher cá nhân</div>
                  <div className="lh-24 fsz-13  text-344054 break-word">Chỉ áp dụng cho khách hàng được chọn.</div>
                </div>
              </Radio.Button>
            </Radio.Group>
          </Form.Item>



          <div className="custom-page-css w-full  gap-2">
            <div className="custom-page-css flex flex-col gap-2">
              <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Số lượng voucher phát hành <span className='text-danger'>*</span></span>
              <Form.Item
                name="quantity"
                validateTrigger="onChange"
                getValueFromEvent={(e) => normalizeNumberInput(e.target.value)}
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng nhập số lượng voucher phát hành!',
                  },
                  {
                    validator: validatePositiveNumberMax12,
                  },
                ]}
              >
                <Input
                  className="w-full custom-input-css custom-page-css border"
                  placeholder="Số lượng voucher phát hành"
                  inputMode="numeric"
                />
              </Form.Item>
            </div>
          </div>
          <div className="custom-page-css w-full grid grid-cols-2 gap-2">
            {/* <div className="custom-page-css flex flex-col gap-2">
              <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Số lần áp dụng cho từng khách hàng <span className='text-danger'>*</span></span>
              <Form.Item
                name="usageCount"
                validateTrigger="onChange"
                getValueFromEvent={(e) => normalizeNumberInput(e.target.value)}
                rules={[
                  { required: true, message: 'Vui lòng nhập số lần áp dụng cho từng khách hàng!' },
                  {
                    validator: validatePositiveNumberMax12,
                  },
                ]}
              >
                <Input
                  className="w-full custom-input-css custom-page-css border"
                  placeholder="Số lần áp dụng cho từng khách hàng"
                  inputMode="numeric"
                />

              </Form.Item>
            </div> */}
            {typeVoucher === 1 &&
              <>
                <div className="custom-page-css flex flex-col gap-2">
                  <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Hình thức giảm <span className='text-danger'>*</span></span>
                  <Form.Item
                    name="role"
                    rules={[{ required: true, message: 'Vui lòng chọn hình thức giảm!' }]}

                  >
                    <Select
                      className='custom-page-css border rounded overflow-hidden'
                      placeholder='Hình thức giảm'
                      options={[
                        { value: RoleType.PRICE, label: 'Số tiền' },
                        { value: RoleType.PERCENT, label: 'Phần trăm' },
                      ]}
                      onChange={(value) => {
                        if (value === RoleType.PERCENT) {
                          form.setFieldsValue({
                            reducedAmount: undefined,
                          });
                        } else {
                          form.setFieldsValue({
                            percentDecrease: undefined,
                          });
                        }
                      }}
                    />
                  </Form.Item>
                </div>
                <div className="custom-page-css flex flex-col gap-2">
                  <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Phần trăm/ Số tiền giảm <span className='text-danger'>*</span></span>
                  {
                    role === RoleType.PERCENT ? (
                      <Form.Item
                        name="percentDecrease"
                        rules={[
                          { required: true, message: 'Vui lòng nhập phần trăm giảm!' },
                          {
                            type: 'number',
                            min: 1,
                            message: 'Giá trị phải lớn hơn 0',
                            transform: (value) => {
                              if (value === undefined || value === null || value === '') {
                                return undefined;
                              }
                              return Number(value);
                            },
                          },
                          {
                            type: 'number',
                            max: 100,
                            message: 'Phần trăm giảm không được vượt quá 100',
                            transform: (value) => {
                              if (value === undefined || value === null || value === '') {
                                return undefined;
                              }
                              return Number(value);
                            },
                          }
                        ]}
                      >
                        <InputNumber<number>
                          className="w-full custom-input-css custom-page-css border"
                          placeholder="Phần trăm"
                          controls={false}
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                          }
                          parser={(value) =>
                            value?.replace(/\./g, '') as unknown as number
                          }
                        />
                      </Form.Item>
                    ) : (
                      <Form.Item
                        name="reducedAmount"
                        dependencies={['orderValueMin']}
                        validateTrigger="onChange"
                        getValueFromEvent={(e) => normalizeNumberInput(e.target.value)}
                        rules={[
                          {
                            required: true,
                            message: 'Vui lòng nhập số tiền giảm!',
                          },
                          {
                            validator: validatePositiveNumberMax12,
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (value === undefined || value === null || value === '') {
                                return Promise.resolve();
                              }

                              const orderValueMin = getFieldValue('orderValueMin');

                              if (
                                orderValueMin === undefined ||
                                orderValueMin === null ||
                                orderValueMin === ''
                              ) {
                                return Promise.resolve();
                              }

                              const reducedAmountRaw = String(value).replace(/\./g, '');
                              const orderValueMinRaw = String(orderValueMin).replace(/\./g, '');

                              if (!/^\d+$/.test(reducedAmountRaw) || !/^\d+$/.test(orderValueMinRaw)) {
                                return Promise.resolve();
                              }

                              const reducedAmountNumber = Number(reducedAmountRaw);
                              const orderValueMinNumber = Number(orderValueMinRaw);

                              if (reducedAmountNumber > orderValueMinNumber) {
                                return Promise.reject(
                                  new Error(
                                    `Số tiền giảm (${reducedAmountNumber.toLocaleString(
                                      'vi-VN'
                                    )}) không được lớn hơn giá trị đơn hàng tối thiểu (${orderValueMinNumber.toLocaleString(
                                      'vi-VN'
                                    )})!`
                                  )
                                );
                              }

                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input
                          className="w-full custom-input-css custom-page-css border"
                          placeholder="Số tiền giảm"
                          inputMode="numeric"
                        />

                      </Form.Item>
                    )
                  }

                </div>
              </>
            }
            <div className="custom-page-css flex flex-col gap-2">
              <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Giá trị đơn hàng tối thiểu </span>
              <Form.Item
                name="orderValueMin"
                validateTrigger="onChange"
                getValueFromEvent={(e) => normalizeNumberInput(e.target.value)}
                rules={[
                  {
                    validator: validatePositiveNumberMax12,
                  },
                ]}
              >
                <Input
                  className="w-full custom-input-css custom-page-css border"
                  placeholder="Giá trị đơn hàng tối thiểu"
                  inputMode="numeric"
                />

              </Form.Item>
            </div>
            <div className="custom-page-css flex flex-col gap-2">
              <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Số tiền giảm tối đa </span>
              <Form.Item
                name="reducedAmountMaximum"
                validateTrigger="onChange"
                getValueFromEvent={(e) => normalizeNumberInput(e.target.value)}
                rules={[
                  {
                    validator: validatePositiveNumberMax12,
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const orderValueMin = getFieldValue('orderValueMin');

                      if (!value || !orderValueMin) {
                        return Promise.resolve();
                      }

                      const reducedAmountRaw = String(value).replace(/\./g, '');
                      const orderValueMinRaw = String(orderValueMin).replace(/\./g, '');

                      if (!/^\d+$/.test(reducedAmountRaw) || !/^\d+$/.test(orderValueMinRaw)) {
                        return Promise.resolve();
                      }

                      const reducedAmountNumber = Number(reducedAmountRaw);
                      const orderValueMinNumber = Number(orderValueMinRaw);

                      if (reducedAmountNumber > orderValueMinNumber) {
                        return Promise.reject(
                          new Error(
                            `Số tiền giảm tối đa (${reducedAmountNumber.toLocaleString(
                              'vi-VN'
                            )}) không được lớn hơn giá trị đơn hàng tối thiểu (${orderValueMinNumber.toLocaleString(
                              'vi-VN'
                            )})!`
                          )
                        );
                      }

                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input
                  className="w-full custom-input-css custom-page-css border"
                  placeholder="Số tiền giảm tối đa"
                  inputMode="numeric"
                />
              </Form.Item>
            </div>
          </div>

          <div className="block pt-2">
            <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Thời gian Voucher hiệu lực </span>

            <div className="custom-page-css grid grid-cols-2 gap-3">
              <div className="block-grid__item">
                <span className="font-regular lh-24 fsz-13 pt-2 text-344054">Bắt đầu <span className='text-danger'>*</span></span>

                <div className="custom-page-css grid grid-cols-2 gap-3">
                  <div className="block-grid__item">
                    <Form.Item
                      name="startDate"
                      rules={[{ required: true, message: 'Vui lòng chọn ngày bắt đầu!' }]}
                    >
                      <DatePicker

                        format="DD/MM/YYYY"
                        placeholder="Chọn ngày"
                        className="custom-input-date w-full"
                        popupClassName="rs-date-picker-dropdown"
                      />
                    </Form.Item>
                  </div>
                  <div className="block-grid__item">
                    <Form.Item
                      name="startTime"
                      rules={[{ type: 'object' as const, required: true, message: 'Vui lòng chọn giờ bắt đầu!' }]}
                    >
                      <TimePicker
                        minuteStep={30}
                        placeholder="Chọn giờ"
                        className="custom-input-date w-full"
                        popupClassName="rs-date-picker-dropdown"
                        format={'HH:mm'}
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div className="block-grid__item">
                <span className="font-regular lh-24 fsz-13 pt-2 text-344054">Hết hiệu lực <span className='text-danger'>*</span></span>

                <div className="custom-page-css grid grid-cols-2 gap-3">
                  <div className="block-grid__item">
                    <Form.Item
                      name="endDate"
                      dependencies={['startDate', 'startTime', 'endTime']}
                      rules={[
                        { required: true, message: 'Vui lòng chọn ngày hết hiệu lực!' },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const startDate = getFieldValue('startDate');
                            if (!value || !startDate) return Promise.resolve();
                            if (value.isBefore(startDate, 'day')) {
                              return Promise.reject(new Error('Ngày kết thúc phải lớn hơn hoặc bằng ngày bắt đầu!'));
                            }
                            return Promise.resolve();
                          }
                        })
                      ]}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        placeholder="Chọn ngày"
                        className="custom-input-date custom-page-css w-full"
                        popupClassName="rs-date-picker-dropdown"
                      />
                    </Form.Item>
                  </div>
                  <div className="block-grid__item">
                    <Form.Item
                      name="endTime"
                      dependencies={['startDate', 'startTime', 'endDate']}
                      rules={[
                        { type: 'object' as const, required: true, message: 'Vui lòng chọn giờ hết hiệu lực!' },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const startDate = getFieldValue('startDate');
                            const startTime = getFieldValue('startTime');
                            const endDate = getFieldValue('endDate');
                            if (!value || !startDate || !startTime || !endDate) return Promise.resolve();
                            const start = startDate.clone().hour(startTime.hour()).minute(startTime.minute()).second(0);
                            const end = endDate.clone().hour(value.hour()).minute(value.minute()).second(0);
                            if (!end.isAfter(start)) {
                              return Promise.reject(new Error('Thời gian kết thúc phải lớn hơn thời gian bắt đầu!'));
                            }
                            return Promise.resolve();
                          }
                        })
                      ]}
                    >
                      <TimePicker
                        minuteStep={30}
                        placeholder="Chọn giờ"
                        className="custom-input-date custom-page-css w-full"
                        popupClassName="rs-date-picker-dropdown"
                        format={'HH:mm'}
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span className="font-regular lh-24 fsz-14 pt-2 text-344054">Điều kiện sử dụng</span>
          <div className="">
            <Form.Item
              name="termsOfUse"
            >
              <TextArea
                placeholder="Điều kiện sử dụng (Ví dụ: áp dụng cho dịch vụ, mua xe, quà tặng, nội bộ..)"
                className="w-full"
              />
            </Form.Item>
          </div>


          {/* voucher cho nhóm */}
          <div className={`${voucherType === 'group' ? 'block' : 'd-none'} pt-4 custom-page-css flex flex-col gap-3`}>
            <div className="custom-page-css flex  items-center justify-between">
              <span className="font-medium lh-24 fsz-16">
                Danh sách nhóm khách hàng {
                  groupCustomerSelected?.length ?
                    `(${groupCustomerSelected.length})` :
                    ''
                }
              </span>
              <button type='button' className='custom-page-css flex  items-center gap-2  border-none bg-transparent px-4 py-1'
                onClick={() => setOpenModalAddGroupCus(true)}
              >
                <div className='custom-page-css flex items-center justify-center rounded-full' style={{
                  height: 20,
                  width: 20,
                  backgroundColor: '#98a2b34d',
                }}>
                  <PlusOutlined style={{ color: '#98A2B3' }} />
                </div>
                <span className='custom-page-css text-667085 text-sm font-medium'>Chọn nhóm khách hàng</span>

              </button>

            </div>
            {
              groupCustomerSelected?.length ?
                <div className="custom-page-css w-full flex  items-center  gap-2 flex-wrap">
                  {
                    groupCustomerSelected?.map(item => (
                      <div key={item.id} className="custom-page-css flex  items-center  gap-2 rounded border px-3 py-1">
                        <span className='custom-page-css text-sm font-regular text-667085'>
                          {item.title} ({formatPrice(item.total)})
                        </span>
                        <CloseOutlined
                          onClick={() => removeGroupCustomerSelected(item.id)}
                          style={{ fontSize: 10, color: '#89898a' }}
                        />
                      </div>
                    ))
                  }

                </div>
                :
                <div className="custom-page-css w-full flex flex-col items-center justify-center gap-3">
                  <img src={empty_image_cus} alt="" />
                  <span className='custom-page-css text-sm font-regular text-667085'>Chưa có nhóm khách hàng nào,
                    <span className='custom-page-css text-sm font-regular text-1890FF cursor-pointer pl-1'
                      onClick={() => setOpenModalAddGroupCus(true)}
                    >thêm ngay</span>
                  </span>
                </div>
            }
          </div>

          {/* Khách hàng, Nhóm cá nhân */}
          <div className={`${voucherType === 'private' ? 'block' : 'd-none'} pt-4 custom-page-css flex flex-col gap-3`}>
            <div className="custom-page-css flex  items-center justify-between">
              <span className="font-medium lh-24 fsz-16">Danh sách khách hàng </span>

              {
                groupCustomerSelected?.length ?
                  <button type='button' className='custom-page-css flex  items-center gap-2  border-none bg-transparent px-4 py-1'
                    onClick={() => setOpenModalAddCustomer(true)}
                  >
                    <div className='custom-page-css flex items-center justify-center rounded-full' style={{
                      height: 20,
                      width: 20,
                      backgroundColor: '#98a2b34d',
                    }}>
                      <PlusOutlined style={{ color: '#98A2B3' }} />
                    </div>
                    <span className='custom-page-css text-667085 text-sm font-medium'>Chọn khách hàng</span>

                  </button>
                  : null
              }


            </div>
            <div className="custom-page-css flex items-start gap-2">
              <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
                <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                  <div className="d-flex align-center w-full">

                    <TreeSelect
                      className='custom-page-css bg-FCFCFD-ant-select w-full  border-none no-focus-border overflow-hidden'
                      multiple
                      showSearch
                      placeholder="Chọn đơn vị"
                      allowClear
                      value={dataFilterMatchedCustomers?.listUnit}
                      treeDefaultExpandAll={false}
                      treeData={sLNationwide}
                      filterTreeNode={(input: string, option: any) =>
                        typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, listUnit: e })}
                    />
                  </div>
                </div>
              </div>

              <div className="custom-page-css h-fit flex-1 d-flex gap-2 overflow-hidden">
                <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center py-2-px justify-between overflow-hidden">
                  <div className="d-flex align-center w-full">
                    <Select
                      showSearch={false}
                      allowClear
                      mode="multiple"
                      className='w-full font-regular p-none-select line-none line-none-item inline-none size-selector border-none '
                      popupClassName="position-dropdow custome-select-item h-popUp"
                      variant="borderless"
                      placeholder="Thương hiệu"
                      options={sLCategoryCar}
                      value={dataFilterMatchedCustomers?.listCategoryCar}
                      onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, listCategoryCar: e })}
                    />
                  </div>
                </div>
              </div>
              <div className='custom-page-css  h-36px flex flex-2'>
                <div className="custom-page-css custom-input-search w-full flex items-center justify-between flex-2 border-F2F4F7 bg-FCFCFD rounded-2  pl-3  overflow-hidden">
                  <input
                    placeholder="Tìm kiếm thông tin khách hàng"
                    className=' border-none  custom-page-css w-full border-none'
                    value={dataFilterMatchedCustomers.search}
                    onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, search: e.target.value })}
                  />
                  <div className="border-l-F2F4F7 h-full d-flex align-center">
                    <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                  </div>
                </div>
              </div>
            </div>
            <div className="custom-page-css w-full flex flex-col gap-3">
              <div className="custom-page-css flex items- gap-1">
                <span className='custom-page-css text-base text-4B4B4B font-regular'>Đã chọn:</span>
                <span className='custom-page-css text-base text-344054 font-regular'>{formatPrice(groupCustomerSelected?.length ? selectedIdCustomer?.length : selectedIdCondUnmatchedCustomersTmp.size)} khách hàng</span>
              </div>
            </div>

            <div className="ag-theme-alpine custom-table-ag custom-css-table "
              style={{ width: '100%', height: 650 }}

            >
              <AgGridReact
                // domLayout="autoHeight"
                className="my-auto-height-grid"
                getRowStyle={(params: any) => ({
                  backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                })}
                columnDefs={memoizedColumnDefs}
                rowData={groupCustomerSelected?.length ? tableDataMatchedCustomers : tableDataUnmatchedCustomers}
                rowHeight={55}
                defaultColDef={{
                  resizable: true
                }}
                overlayNoRowsTemplate={NodataTable}
                rowSelection={{ mode: 'multiRow' }}
                getRowId={getRowId}
                onGridReady={onGridReady}
                onSelectionChanged={groupCustomerSelected?.length ? onSelectionChanged : onSelectionChangedUnMatch}
              />
            </div>
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination
                  showSizeChanger
                  current={
                    groupCustomerSelected?.length
                      ? paginationMatchedCustomers.current
                      : paginationUnmatchedCustomers.current
                  }

                  pageSize={
                    groupCustomerSelected?.length
                      ? paginationMatchedCustomers.pageSize
                      : paginationUnmatchedCustomers.pageSize
                  }

                  total={
                    groupCustomerSelected?.length
                      ? paginationMatchedCustomers.total
                      : paginationUnmatchedCustomers.total
                  }
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={(total) => {
                    const paginationData = groupCustomerSelected?.length
                      ? dataPagination(
                        paginationMatchedCustomers.total,
                        paginationMatchedCustomers.pageSize,
                        paginationMatchedCustomers.current
                      )
                      : dataPagination(
                        paginationMatchedCustomers.total,
                        paginationMatchedCustomers.pageSize,
                        paginationMatchedCustomers.current
                      );

                    return `Tổng cộng ${paginationData.totalPage} trang`;
                  }}
                  className='rs-pagination'
                  onChange={onPagination}
                />
              </div>
            </ConfigProvider>
          </div>
        </Form>
      </div>
    </Layout>
  );
}

export default VoucherCreate;
